const faqs = [
  {
    question: "Combien de temps pour une réparation à Lingolsheim ?",
    answer:
      "À Lingolsheim, notre proximité avec l'atelier (82 rue de Heidenberg, Strasbourg) nous permet d'intervenir le jour même dans la majorité des cas. Pour les urgences, nous priorisons un délai de 4 heures. Vous pouvez nous appeler au 03 74 47 10 36 pour un rendez-vous rapide.",
  },
  {
    question: "Le déplacement est-il gratuit à Lingolsheim ?",
    answer:
      "Oui, le déplacement est entièrement gratuit à Lingolsheim comme dans tout le Bas-Rhin. Nous ne facturons aucun frais de déplacement. Le devis est également gratuit et sans engagement.",
  },
  {
    question: "Quelles marques réparez-vous à Lingolsheim ?",
    answer:
      "Nous réparons toutes les marques : Ferco, GU, Roto, Maco, Siegenia, Winkhaus, Vachette et bien d'autres. Les pavillons de Lingolsheim utilisent des mécanismes variés selon l'âge de la construction. Nos techniciens emportent les pièces les plus courantes et peuvent commander rapidement les modèles spécifiques.",
  },
];

export default function FAQ() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-10">
          Questions fréquentes — Lingolsheim
        </h2>
        <div className="space-y-4 max-w-3xl">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-rose-100 p-5 md:p-6"
            >
              <h3 className="font-serif text-base md:text-lg font-semibold text-plum-dark mb-3">
                {faq.question}
              </h3>
              <p className="text-plum-dark text-sm md:text-base leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}